import _ from 'lodash'
import { Inject, Injectable, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import { selectAccessToken } from './state/auth.selectors'
import { Store } from '@ngrx/store'
import { IAuthAccessToken } from './state/auth.reducers'

@Injectable({
    providedIn: 'root'
})
export class AuthContextStorageService implements OnDestroy {

    private accessToken: IAuthAccessToken

    #selectAccessToken: Subscription

    constructor(@Inject(Store) private store: Store,
    ) {
        this.#selectAccessToken = this.store.select(selectAccessToken).subscribe(data => {
            this.accessToken = data
        })
    }

    ngOnDestroy() {
        this.#selectAccessToken?.unsubscribe()
    }

    getToken(): string {
        return this.accessToken?.token
    }

    getAuthorizations(): any {
        return _.cloneDeep(this.accessToken.authorizations)
    }

    getExpiration(): any {
        return this.accessToken?.expiration
    }

    getProjectKey(): string {
        return this.accessToken?.projectKey
    }

    hasPermission(action): boolean {
        const authorizations = _.cloneDeep(this.accessToken?.authorizations)
        let result = true

        if (authorizations) {
            const actions = action.split(',')

            for (let i = 0; i < actions.length; i++) {
                if (authorizations.indexOf(actions[i]) === -1) {
                    result = false
                }
            }
        }
        return result
    }

    isAuthenticated(): boolean {
        return (this.getToken() !== null && this.getExpiration() != null && new Date(this.getExpiration() * 1000) >= new Date())
    }

    isUserAdmin(): boolean {
        return this.accessToken?.adminPermission
    }
}